import { render, staticRenderFns } from "./ValidaHoleriteQRCode.vue?vue&type=template&id=a54a8d0e&"
import script from "./ValidaHoleriteQRCode.vue?vue&type=script&lang=js&"
export * from "./ValidaHoleriteQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports